import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';

interface AdminSearchInputProps {
  placeholder?: string;
  onSearch: (value: string) => void;
  debounceMs?: number;
  minChars?: number;
  className?: string;
  defaultValue?: string;
}

const AdminSearchInput: React.FC<AdminSearchInputProps> = ({
  placeholder = 'Search...',
  onSearch,
  debounceMs = 500,
  minChars = 2,
  className = '',
  defaultValue = '',
}) => {
  const [value, setValue] = useState(defaultValue);
  const isInitialMount = useRef(true);

  useEffect(() => {
    // Always skip initial mount — parent already loads data on mount (even when defaultValue is set)
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }
    const timer = setTimeout(() => {
      if (value.length >= minChars || value.length === 0) {
        onSearch(value);
      }
    }, debounceMs);
    return () => clearTimeout(timer);
  }, [value]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className={`relative ${className}`}>
      <FontAwesomeIcon
        icon={faMagnifyingGlass}
        className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"
      />
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder={placeholder}
        className="border border-gray-300 rounded-md px-2 py-1.5 pl-9 w-full text-sm bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-400"
      />
    </div>
  );
};

export default AdminSearchInput;
